import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import DepartmentsPurchaseOrderTable from './DepartmentsPurchaseOrderTable';
import loader from '../../../../../../assets/img/icons/TizetiLoaderColored.gif';
import { usePurchaseOrder } from '../../../../../../hooks/shared/purchase-order/usePurchaseOrder';

const DepartmentsPurchaseOrderBody = () => {
  const { lists, pages, isLoading, handlePageClick, getAccountsPurchaseOrder } = usePurchaseOrder();

  useEffect(() => {
    getAccountsPurchaseOrder();
  }, []);

  return (
    <div className="col-12 mt-5">
      <div className="col-12 m-0 p-0 after-summary">
        <div className="row ml-3">
          <div className="card x-panel m-0 p-0">
            <div className="table-responsive content col-12 mt-5 px-0">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>Amount</th>
                    <th>Department</th>
                    <th>Budget Code</th>
                    <th>Manager Status</th>
                    <th>Procurement Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="11" className="text-center">
                        <img src={loader} alt="loading gif" />
                      </td>
                    </tr>
                  ) : (
                    <DepartmentsPurchaseOrderTable lists={lists} />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {pages > 1 ? (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakLabel="..."
          breakClassName="break-me"
          pageCount={pages}
          marginPagesDisplayed={3}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName="pagination"
          subContainerClassName="pages pagination"
          activeClassName="active"
        />
      ) : null}
    </div>
  );
};

export default DepartmentsPurchaseOrderBody;
